import "./App.scss";
import React, { useEffect, useState } from "react";
import { messaging } from "./firebase";
import { getToken } from "firebase/messaging";
import RouterComponent from "./router";
import { getAllData } from "./services/tasks/tasks";
import { useParams } from "react-router-dom";
function App() {
  const [dashData, setDashData] = useState([])
  async function requestPermission() {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      // alert('You granted for the notification')
      const token = await getToken(messaging, { vapidKey: 'BH9WnWMHZzbQR7nW2o244Jm_TG9tCGcJNqoLgHQF-BbFniRIBpEjG15LPED2K6KrUUIgTKqgf1CBnxLLq8WevMQ' })
      console.log('token', token);
    } else if (permission === 'denied') {
      // alert('You denied for the notification')
    }
  }

  useEffect(() => {
    requestPermission()
  }, [])

  const getData = async () => {
    const data = await getAllData().then((res) => {
      let filterData = res.data.data.filter((item) => item.userId === localStorage.getItem('userId'));
      setDashData(filterData)
    }
    )
  }
  useEffect(() => {
    getData();
  }, [])


  return (
    <div>
      <RouterComponent dashData={dashData} />
    </div>
  );
}

export default App;
